function Me() {
  const calculateAge = () => {
    const birthDate = new Date("10/31/2001");
    const todaysDate = new Date();

    // Get general age calculation
    let years = todaysDate.getFullYear() - birthDate.getFullYear();

    // Adjust more precisely according to month & day
    if (
      todaysDate.getMonth() < birthDate.getMonth() ||
      (todaysDate.getMonth() === birthDate.getMonth() &&
        todaysDate.getDate() < birthDate.getDate())
    ) {
      years--;
    }

    return years.toString();
  };

  return (
    <div className="Me">
      <h2>Who am I?</h2>
      <div className="flex justify-center align-center half-half">
        <span>
          <p>
            Hi, I’m Luke De-Ath, a self-taught aspiring web developer based in
            Bolton, Greater Manchester.
          </p>
          <p>
            I’m passionate about building <strong>customisable</strong> websites
            from scratch, allowing for unique designs without relying on
            templates or website builders.
          </p>
          <p>
            In my free time, I’m dedicated to expanding my skills and creating
            tailored web pages for others.
          </p>
          <p>Age: {calculateAge()}</p>
        </span>
        <img
          src="/Images/Me.jpg"
          alt="Luke De-Ath smiling in an outdoor setting."
          loading="lazy"
        />
      </div>
    </div>
  );
}

export default Me;
